import { ethers } from 'ethers';

const formatAccount = (address: string): string =>
    `${(address || ethers.constants.AddressZero).slice(0, 6)}...${(
        address || ethers.constants.AddressZero
    ).slice(-4)}`;

export default formatAccount;
